import { EmploymentInformation } from "@/types";
import { fieldTypes, NumericFieldProps, SectionHeader } from "@ucl/library";
import { FC } from "react";
import { FieldComplexV2 } from "./FieldComplexV2";
import { COMPLEX_FIELD_KEYS } from "@/constants/fieldKeys";
import "./ComplexFields.scss";

export interface EmploymentInformationComplexValue {
  readOnly?: boolean;
  showHeader?: boolean;
  showAttorneyBarNumber?: boolean;
  headerLabel?: string;
}

export interface EmploymentInformationComplexFieldProps
  extends fieldTypes.BaseFieldProps<EmploymentInformation> {}

export const EmploymentInformationComplexField: FC<EmploymentInformationComplexFieldProps> = (
  props
) => {
  const employmentInformationComplexValue =
    props.complexFieldValue as EmploymentInformationComplexValue;
  const readOnly = employmentInformationComplexValue?.readOnly || props.readOnly;
  const showAttorneyBarNumber = employmentInformationComplexValue?.showAttorneyBarNumber || false;

  return (
    <section className="complex-field-container employment-information">
      <SectionHeader label={employmentInformationComplexValue?.headerLabel || props.label} hidden={!employmentInformationComplexValue?.showHeader} />
      <div className="complex-field-content">
        <FieldComplexV2
          {...props}
          complexFieldKey={COMPLEX_FIELD_KEYS.EMPLOYMENT_INFORMATION.EMPLOYMENT_TYPE}
          complexFieldProps={{ disabled: readOnly }}
        />
        <FieldComplexV2
          {...props}
          complexFieldKey={COMPLEX_FIELD_KEYS.EMPLOYMENT_INFORMATION.EMPLOYER}
          complexFieldProps={{ disabled: readOnly }}
        />
        <FieldComplexV2
          {...props}
          complexFieldKey={COMPLEX_FIELD_KEYS.EMPLOYMENT_INFORMATION.JOB_TITLE}
          complexFieldProps={{ disabled: readOnly }}
        />
        <FieldComplexV2
          {...props}
          complexFieldKey={COMPLEX_FIELD_KEYS.EMPLOYMENT_INFORMATION.LENGTH_OF_EMPLOYMENT_YEARS}
          complexFieldProps={
            {
              disabled: readOnly,
              showIncrementButtons: false,
              format: "n0",
            } as NumericFieldProps
          }
        />
        {showAttorneyBarNumber && (
          <FieldComplexV2
            {...props}
            complexFieldKey={COMPLEX_FIELD_KEYS.EMPLOYMENT_INFORMATION.ATTORNEY_BAR_NUMBER}
            complexFieldProps={{
              disabled: readOnly,
            }}
          />
        )}
      </div>
    </section>
  );
};
